import { SET_USER_LOADING, SET_USER_PERMISSIONS } from '@state-management/constants';
import { MeUserResponse } from '../models/state.models';

export class SetLoggedinUserStatusAction {
  readonly type = SET_USER_PERMISSIONS;
  constructor(public readonly payload?: { data: MeUserResponse | null }) {}
}

export class SetUserLoadingAction {
  readonly type = SET_USER_LOADING;
  constructor(public readonly payload?: { data: boolean }) {}
}
